import { TableCell, DateCell } from 'ui/tableCell';
import { AccordionHeader, AccordionContent } from 'ui/accordion';
import { JsonView } from 'ui/treeView';
import { Link } from 'ui/links';
import _isEmpty from 'lodash/isEmpty';
import { StyledAccordion } from './ScheduledMessages.styled';
import type { ScheduledMessagesTableColumnData } from '../types';

const EMAIL_COLUMN: ScheduledMessagesTableColumnData = {
  align: 'flex-start',
  name: 'Email',
  value: 'email',
  RowCell: ({ row }) => (
    <TableCell>
      <Link useReactRouter inTable href={`/users/profiles/${encodeURIComponent(row.email)}`}>
        {row.email}
      </Link>
    </TableCell>
  ),
};

const USER_IDENTIFIER_COLUMN: ScheduledMessagesTableColumnData = {
  align: 'flex-start',
  name: 'User Identifier',
  value: 'userIdentifier',
  RowCell: ({ row }) => (
    <TableCell>
      {row.userIdentifier && (
        <Link
          useReactRouter
          inTable
          href={`/users/profiles/${encodeURIComponent(row.userIdentifier)}`}
        >
          {row.userIdentifier}
        </Link>
      )}
    </TableCell>
  ),
};

const userColumn = (isUuidBased: boolean) => (isUuidBased ? USER_IDENTIFIER_COLUMN : EMAIL_COLUMN);

export const STATIC_SCHEDULED_MESSAGES_COLUMNS: ScheduledMessagesTableColumnData[] = [
  {
    name: 'Created',
    align: 'flex-start',
    value: 'createdAt',
    RowCell: ({ row }) => <DateCell timestamp={row.createdAt} />,
  },
  {
    name: 'Campaign ID',
    align: 'flex-start',
    value: 'campaignId',
    RowCell: ({ row }) => <TableCell>{row.campaignId}</TableCell>,
  },
  {
    name: 'Campaign Name',
    align: 'flex-start',
    value: 'campaignName',
    RowCell: ({ row }) => (
      <TableCell>
        <Link
          useReactRouter
          inTable
          href={`/analytics/campaignPerformance?campaignId=${row.campaignId}`}
        >
          {row.campaignName}
        </Link>
      </TableCell>
    ),
  },
  {
    name: 'Send At',
    align: 'flex-start',
    value: 'sendAt',
    RowCell: ({ row }) => <DateCell timestamp={row.sendAt} />,
  },
  {
    name: 'Data Fields',
    align: 'flex-start',
    value: 'dataFields',
    RowCell: ({ row }) => {
      const data = row.dataFields;
      return (
        <TableCell>
          {_isEmpty(data) ? (
            ''
          ) : (
            <StyledAccordion>
              <AccordionHeader data-test="scheduled-messages-table-accordion-button">
                Expand to see data fields
              </AccordionHeader>
              <AccordionContent>
                <JsonView src={data} />
              </AccordionContent>
            </StyledAccordion>
          )}
        </TableCell>
      );
    },
  },
];

export const createScheduledMessagesColumns = (
  isUuidBased: boolean,
): ScheduledMessagesTableColumnData[] => [
  {
    align: 'flex-start',
    name: 'ID',
    RowCell: ({ row }) => <TableCell>{row.id}</TableCell>,
    value: 'id',
  },
  userColumn(isUuidBased),
  ...STATIC_SCHEDULED_MESSAGES_COLUMNS,
];
